import { render, staticRenderFns } from "./SendNotificationForm.vue?vue&type=template&id=9e78afd8"
import script from "./SendNotificationForm.vue?vue&type=script&lang=js"
export * from "./SendNotificationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports